import * as zod from 'zod';

import { CameraIntegration } from '@sb/integrations/types/cameraTypes';
import { Step } from '@sb/remote-control/types';
import {
  DEFAULT_REGION_OF_INTEREST,
  Expression,
  RegionOfInterest,
} from '@sb/routine-runner';
import { FileNamePart } from '@sb/routine-runner/Step/Capture/captureConfig';

export namespace CaptureStep {
  export const name = 'Capture';
  export const description =
    'Capture and save a single frame from the camera stream';
  export const librarySection = Step.LibrarySection.Vision;
  export const argumentKind = 'Capture';
  export const featureFlag = 'captureStep';
  export const deviceKinds = [
    'WristCamera',
    'Camera',
    'FTPServer',
    'S3Bucket',
  ] as const;

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    cameraEquipmentId: zod.string().optional(),
    camera: CameraIntegration.optional(),
    regionOfInterest: RegionOfInterest.default(
      DEFAULT_REGION_OF_INTEREST,
    ).optional(),
    saveEquipmentId: zod.string(),
    saveFilepath: Expression.optional(),
    saveMetadata: zod.boolean().default(false),
    fileName: zod.array(FileNamePart).optional(),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'Capture',
      args: {
        camera: args.camera,
        cameraEquipmentId: args.cameraEquipmentId,
        regionOfInterest: args.regionOfInterest,
        saveEquipmentId: args.saveEquipmentId,
        saveFilepath: args.saveFilepath,
        saveMetadata: args.saveMetadata,
        fileName: args.fileName,
      },
    };
  };
}

CaptureStep satisfies Step.StepKindInfo;
